import React,{useState,useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEmo } from '@fortawesome/free-solid-svg-icons';

const SubjectTopicAnalysis = (props) => {
    const studentResult = props.studentResult !== undefined && props.studentResult;
    const studentSubject = studentResult.subject !== undefined && studentResult.subject
    const subjectTopics = studentResult.topic !== undefined && studentResult.topic
    const subjectName = props.subjectName !==undefined && props.subjectName;
    const subjectIndex = props.subjectIndex !==undefined && props.subjectIndex
    const [subjectItem, setSubjectItem] = useState();
    
    useEffect(() => {
        studentSubject !==undefined && studentSubject.map((item,key) => {
            if(item.fieldvalue==subjectIndex)
            {
                return(
                    setSubjectItem(item)
                )
            }
    })
    },[])

    let bio = []

    let subjectTopicContain =[];
    for( let tpinc in subjectTopics[subjectName]){
        let subtoparr=[];
        for (let topic in  subjectTopics[subjectName][tpinc]) {
            subtoparr[topic]=subjectTopics[subjectName][tpinc][topic];
        }
        subjectTopicContain[tpinc]=subtoparr;
    }


    let quest_total = 0;
    let crct_total = 0;
    let incrt_total = 0;
    let lft_total = 0;
    let category_name = '';

    return (
        <>
        <div className='card p-4 subject__analysis_cotentWrapper border-rounded mb-4'>
        <div className='subject__analysis_headerWrap'>
            <h3>{subjectName}</h3>
            <ul className='analysis_header_list'>
                <li>Total Questions {subjectItem !==undefined &&subjectItem.total_question}</li>
                <li>Correct {subjectItem !==undefined&& subjectItem.correct_question}</li>
                <li>Incorrect {subjectItem !==undefined && subjectItem.attempt_question - subjectItem.correct_question}</li>
                <li>Left {subjectItem !==undefined && subjectItem.total_question - subjectItem.attempt_question}</li>
            </ul>
         
        </div>
        <div className='table-responsive'>
            <table className='table align-middle mb-0 table-striped table-sm'>
                <thead className='table-head-primary'>
                    <tr>
                        <th>Topic Name</th>
                        <th>Out Of</th>
                        <th>Correct</th>
                        <th>Incorrect</th>
                        <th colSpan={2}>Left</th>
                    </tr>
                </thead>
                <tbody>
                        {subjectTopicContain !== undefined && subjectTopicContain.map(item => {
                            // setSubjectItem(item)
                            // category_name = item.category
                            quest_total = quest_total + parseInt(item.total_question)
                            crct_total = crct_total + parseInt(item.correct_question)
                            incrt_total = incrt_total + parseInt(item.attempt_question - item.correct_question)
                            lft_total = lft_total + parseInt(item.total_question - item.attempt_question)
                            return (
                                <tr>
                            <td>{item.fieldvalue}</td>
                            <td>{item.total_question}</td>
                            <td>{item.correct_question}</td>
                            <td>{item.attempt_question - item.correct_question }</td>
                            <td>{item.total_question - item.attempt_question}</td>
                            </tr>
                            )  
                        })}
                </tbody>

                <tfoot className='table-primary border-top'>
                    <tr className='total_Cal_row'>
                    <>
                        <td>Total</td>
                        <td>{quest_total} </td>
                        <td>{crct_total}</td>
                        <td>{incrt_total}</td>
                        <td colSpan={2}>{lft_total}</td>
                        </>
                </tr> 
                </tfoot>
            </table>
        </div>
        </div>
        </>
    );
}

export default SubjectTopicAnalysis